import React from 'react';

import PreviewWrapper from './controls/PreviewWrapper'

import ButtonControl from './controls/Button';

import InputControl from './controls/Input';
import MultilineInputControl from './controls/MultilineInput';
import DateInputControl from './controls/DateInput';
import TimeInputControl from './controls/TimeInput';
import DateCalendarControl from './controls/DateCalendar';
import SelectionControl from './controls/SelectionControl';
import DropDownControl from './controls/DropDown';
import MaskInputControl from './controls/MaskInput';
import NumericStepperControl from './controls/NumericStepper';
import PasswordInputControl from './controls/PasswordInput';

import TextControl from './controls/Text';
import SeparatorControl from './controls/Separator';
import BulletTextControl from './controls/BulletText';

import GroupControl from './controls/Group';

import WebSignatureControl from './controls/WebSignature';
import SliderControl from './controls/Slider';
import TableControl from './controls/Table';
import RankingControl from './controls/Ranking';
import ListControl from './controls/List';
import PictureControl from './controls/Picture';
import ProgressBarControl from './controls/ProgressBar';
import CaptchaControl from './controls/Captcha';
import FileAttachmentControl from './controls/FileAttachment';

// --- Fallback Component ---
const DefaultContent = ({ control }) => (
  <div style={{ border: '1px dashed grey', fontSize: '10px', padding: '2px', width: '100%', height: '100%', overflow: 'hidden' }}>
    {control.factoryKey}
  </div>
);

const NoShowControl = () => (
  <></>
);

//--- The Factory Component ---//
export const ControlPreviewFactory = (props) => {
  const { control } = props;
  const ContentComponent = componentMap[control.factoryKey] || DefaultContent;

  return (
    <PreviewWrapper {...props}>
      <ContentComponent {...props} />
    </PreviewWrapper>
  );
};



const componentMap = {

  //Layout
  'control_text': TextControl,
  'control_small_text': TextControl,
  'control_large_heading': TextControl,
  'control_medium_heading': TextControl,
  'control_small_heading': TextControl,
  'control_link': TextControl,
  'control_bullet_text': BulletTextControl,
  'control_horizontal_separator': SeparatorControl,
  'control_vertical_separator': SeparatorControl,

  //Buttons
  'control_button': ButtonControl,
  'control_submit_button': ButtonControl,
  'control_page_button': ButtonControl,
  'control_print_button': ButtonControl,
  'control_play_form_button': ButtonControl,
  'control_play_report_button': ButtonControl,

  //Inputs
  'control_text_input': InputControl,
  'control_numeric_input': InputControl,
  'control_password_input': PasswordInputControl,
  'control_multiple_text_input': MultilineInputControl,
  'control_date_input': DateInputControl,
  'control_time_input': TimeInputControl,
  'control_date_calendar': DateCalendarControl,
  'control_checkbox': SelectionControl,
  'control_radio_button': SelectionControl,
  'control_drop_down': DropDownControl,
  'control_mask_text_input': MaskInputControl,
  'control_numeric_stepper': NumericStepperControl,

  //Groups
  'control_checkbox_group': GroupControl,
  'control_radio_button_group': GroupControl,
  'control_group': GroupControl,

  //Advanced
  'control_websignature': WebSignatureControl,
  'control_vertical_slider': SliderControl,
  'control_horizontal_slider': SliderControl,
  'control_table': TableControl,
  'control_ranking': RankingControl,
  'control_list': ListControl,
  'control_picture': PictureControl,
  'control_progress_bar': ProgressBarControl,
  'control_captcha': CaptchaControl,
  'control_file_attachment': FileAttachmentControl,
  'control_timer': NoShowControl
};


